import { useCallback, useSyncExternalStore } from "react";

// One MediaQueryList per distinct query, shared by every caller (a card grid mounts
// one hook per tile).
const lists = new Map<string, MediaQueryList>();
function listFor(query: string): MediaQueryList {
  let mql = lists.get(query);
  if (!mql) {
    mql = window.matchMedia(query);
    lists.set(query, mql);
  }
  return mql;
}

/** True while `query` matches; correct from the first render. */
export function useMediaQuery(query: string) {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = listFor(query);
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => listFor(query).matches,
    () => false,
  );
}
